import React from "react";

import { ApolloError } from "@apollo/client";

import { Data } from "components/Graph/util";
import GraphSection from "components/Graph/GraphSection";
import DateRangeGraph from "components/Graph/DateRangeGraph";

type Props = {
  data: Data | null | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  className?: string;
};

function QueryPerformanceGraph({ data, loading, error, className }: Props) {
  const noData = !loading && !error && data == null;

  return (
    <GraphSection
      noData={noData}
      loading={loading}
      error={error}
      className={className}
    >
      <DateRangeGraph
        data={data as Data}
        axes={{
          left: {
            format: "duration ms",
            tipFormat: (y) => y.toFixed(2) + " ms",
          },
        }}
        series={[
          {
            key: "avgTime",
            label: "Median",
            tipLabel: "Median",
          },
          {
            key: "pct90th",
            defaultDisabled: true,
            label: "90th Percentile",
            tipLabel: "P90",
          },
          {
            key: "pct95th",
            label: "95th Percentile",
            tipLabel: "P95",
          },
          {
            key: "pct98th",
            defaultDisabled: true,
            label: "98th Percentile",
            tipLabel: "P98",
          },
          {
            key: "pct99th",
            defaultDisabled: true,
            label: "99th Percentile",
            tipLabel: "P99",
          },
          { key: "avgIotime", label: "Avg I/O Time" },
        ]}
      />
    </GraphSection>
  );
}

export default QueryPerformanceGraph;
